import { useMatch } from 'react-router-dom';
import useVenueRoute from 'hooks/useVenueUrl/useVenueRoute';

const useSessionIdFromRoute = () => {
    const route = useVenueRoute('/agenda/activity/:activityId');
    const activityMatch = useMatch(route);
    const sessionId = activityMatch?.params?.activityId;
    return { sessionId: Number(sessionId) };
};

export default useSessionIdFromRoute;
